<script>
  export let size = 40;
</script>

<svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="11" y="22" width="4.75" height="7" fill="currentColor" />
  <rect x="17.625" y="16.5" width="4.75" height="12.5" fill="currentColor" />
  <rect x="24.25" y="11" width="4.75" height="18" fill="currentColor" />
  <rect x="9" y="27" width="22" height="2" fill="currentColor" />
</svg>
